import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Spacer, PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { MerchantCodeTab } from "./merchantCode";
import { MerchantGroupTab } from "./merchantGroup";
import "../../i18n/i18n";

export const MerchantFix = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "merchantGroup",
  );

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/merchant_fix/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  const tabs = [
    {
      name: "merchantGroup",
      title: t("merchantFix.tab.merchantGroup"),
    },
    {
      name: "merchantCode",
      title: t("merchantFix.tab.merchantCode"),
    },
  ];

  return (
    <PageDS
      title={t(`merchantFix.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <MerchantGroupTab />
      <MerchantCodeTab />
    </PageDS>
  );
};
